import React from 'react';
import Header from './components/Header';
import Home from './pages/Home';

export default function App() {
  return (
    <div className="min-h-screen bg-slate-50">
      <Header />
      <main className="container mx-auto p-4">
        <Home />
      </main>
    </div>
  );
}
